export enum BOOKMARK_STATUS {
	RECENT = 'recent',
	COMPLETED = 'completed',
}
